import { Pagination } from "antd";
import { useState } from "react";

export type PagingProps = {
    page?: number,
    setPage?: (page: number) => void,
    pageSize: number,
    setPageSize?: (pageSize: number) => void,
    total?: number,
    setTotal?: (total: number) => void
};

export function useStatefulPaging(props?:{
    defaultSize?: number,
}) : PagingProps {

    const [ page, setPage ] = useState(1);
    const [ pageSize, setPageSize ] = useState((props && props.defaultSize) || 21);
    const [ total, setTotal ] = useState(0);

    return { page, setPage, pageSize, setPageSize, total, setTotal };
}

export function Paginator(props: PagingProps) {
    return (
        <Pagination className="pagination" style={{overflow: "hidden"}}
            defaultCurrent={props.page} defaultPageSize={props.pageSize} total={props.total}
            onShowSizeChange={(page: number, pageSize: number) => {
                props.setPage && props.setPage(page);
                props.setPageSize && props.setPageSize(pageSize);
            }}
            onChange={(page: number, pageSize: number) => {
                props.setPage && props.setPage(page);
                props.setPageSize && props.setPageSize(pageSize);
            }}
        />
    );
}